import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import { useAuth, signOut } from "./lib/auth";
import { ensureUserProfile } from "./lib/firestore";
import { SignIn } from "./components/SignIn";
import { RosterPage } from "./components/RosterPage";
import { MonthBoard } from "./components/MonthBoard";
import { EditorPage } from "./components/EditorPage";

function AppShell() {
  const { user, loading } = useAuth();
  const [profileReady, setProfileReady] = useState(false);

  useEffect(() => {
    if (!user) return;
    ensureUserProfile(user.uid, user.displayName ?? user.email ?? "Educator", user.email ?? "")
      .finally(() => setProfileReady(true));
  }, [user]);

  if (loading) {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Loading…</p>
      </main>
    );
  }

  if (!user) return <SignIn />;
  if (!profileReady) {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Setting up profile…</p>
      </main>
    );
  }

  return (
    <BrowserRouter>
      <header className="border-b px-4 py-3 flex justify-between items-center">
        <Link to="/" className="font-semibold">Learning Stories</Link>
        <nav className="flex gap-4 text-sm">
          <Link to="/" className="text-gray-700">Board</Link>
          <Link to="/roster" className="text-gray-700">Roster</Link>
          <button onClick={() => signOut()} className="text-gray-500">Sign out</button>
        </nav>
      </header>
      <Routes>
        <Route
          path="/"
          element={<MonthBoard uid={user.uid} displayName={user.displayName ?? "Educator"} />}
        />
        <Route path="/roster" element={<RosterPage uid={user.uid} />} />
        <Route path="/edit/:reportId" element={<EditorPage uid={user.uid} />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return <AppShell />;
}
